import React, { FunctionComponent } from 'react';
import { Modal, View, StyleSheet, StatusBar, Pressable } from 'react-native';
// 1. Importamos useSafeAreaInsets para obtener los píxeles exactos del notch
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { 
    HStack, 
    Text, 
    Icon, 
} from '@gluestack-ui/themed';
import { Ionicons } from "@expo/vector-icons";
import { StatusScreen } from '../../screens';

export interface IModalFullProps {
    visible?: boolean;
    title?: string;
    rightButtons?: any;
    closeButton_onPress?: () => void;
    footer?: any;
    children?: React.ReactNode;
}

export const ModalFull: FunctionComponent<IModalFullProps> = (props) => {
    // 2. Leemos los insets exactos del dispositivo
    const insets = useSafeAreaInsets();

    return (
        <Modal 
            visible={props.visible} 
            animationType="slide" 
            transparent={false} // 3. Cambiado a false para modal pantalla completa nativo
            onRequestClose={props.closeButton_onPress}
        >
            <StatusBar backgroundColor="#3b82f6" barStyle="light-content" />

            <View style={styles.modalContent}>
                
                {/* HEADER - Aplicamos paddingTop dinámico con el inset top */}
                <HStack 
                    bg="$primary400" 
                    w="$full" 
                    alignItems="center" 
                    justifyContent="space-between"
                    px="$4" 
                    pb="$3"
                    style={{ paddingTop: insets.top > 0 ? insets.top : 12 }}
                >
                    <View style={styles.titleContainer}>
                        <Text color="$white" size="md" fontWeight="$bold" numberOfLines={1}>
                            {props.title ?? ""}
                        </Text>
                    </View>

                    <HStack alignItems="center" space="md">
                        {props.rightButtons}
                        {props.closeButton_onPress && (
                            <Pressable 
                                onPress={props.closeButton_onPress}
                                hitSlop={15}
                                style={styles.closeButton}
                            >
                                <Icon as={Ionicons} name="close" color="$white" size="md" />
                            </Pressable>
                        )}
                    </HStack>
                </HStack>

                {/* BODY */}
                <View style={styles.body}>
                    {props.children}
                </View>

                {/* FOOTER - Aplicamos paddingBottom dinámico para la barra de gestos */}
                {props.footer && (
                    <View style={[
                        styles.footerContainer, 
                        { paddingBottom: insets.bottom > 0 ? insets.bottom : 8 }
                    ]}>
                        {props.footer}
                    </View>
                )}
            </View>

            <StatusScreen />
        </Modal>
    );
};

const styles = StyleSheet.create({
    modalContent: { 
        flex: 1,
        backgroundColor: '#fff',
    },
    titleContainer: { 
        flex: 1, 
        marginRight: 10 
    },
    body: { 
        flex: 1, 
        backgroundColor: "#fff"
    },
    footerContainer: { 
        width: "100%",
        borderTopWidth: 1,
        borderTopColor: '#f0f0f0', 
        flexDirection: "row"
    },
    closeButton: {
        padding: 5,
        justifyContent: 'center',
        alignItems: 'center'
    }
});